import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceDesTwo() {
  return (
    <Container className="p-3">
      <Row style={{ justifyContent: 'center' }} >
        <Row className='mt-3'>
          <Col className='service_des_title' > Colorectal Problems </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            <p className='service_des_p' >
              The colon is a long, muscular tube that is about 5 feet long. The lower end of the colon is attached to the rectum and when stool enters the rectum, it propels it into the colon.
            </p>
            <p className='service_des_p' > An enlarged or inflamed colon can be seen as a sign of colorectal cancer.</p>
            <p className='service_des_p' > The treatment for colorectal cancer may involve surgery followed by chemotherapy and/or radiation therapy. </p>
            <p className='service_des_p' >
              A colectomy is a surgical procedure to remove part or all of the colon and rectum. A colectomy is often done to treat an ulcerative colitis or Crohn's disease, which can't be managed with medications alone.
            </p>
            <p className='service_des_p' >
              The word "colorectal" comes from the Latin words "colorectus" meaning "to cut through." Colectomies are major abdominal surgeries that remove part or all the large intestine, depending on the extent of the disease. Usually, surgery is considered in patients who have had severe ulcerative colitis symptoms despite treatment with medication for a long time and who have not responded well to other treatments.
            </p>
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col className='service_des_title'>Colorectal Surgical Procedures </Col>
        </Row>
        <Row className='mt-3'>
          <Col className='service_des_p' >
            <p> The following is a list of the most common procedures performed by surgeons at the Division of Colorectal Surgery: </p>
            <ul>
              <li>Ambulatory hemorrhoidal surgery</li>
              <li>Hemorrhoidal banding</li>
              <li> Hemorrhoidal excision</li>
              <li> Internal-lateral sphincterotomy</li>
              <li> Repair of fistula and fissure</li>
              <li> Solitary rectal ulcer syndrome</li>
            </ul>
            <p> Our surgeons are able to perform many surgeries with robotic assistance, for smaller incisions, less post-operative pain and faster recovery.</p>
          </Col>
        </Row>
      </Row>
    </Container>
  )
}

export default ServiceDesTwo